import { render, staticRenderFns } from "./RoundedCrossSvg.vue?vue&type=template&id=f4222bfe&"
import script from "./RoundedCrossSvg.vue?vue&type=script&lang=ts&"
export * from "./RoundedCrossSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports